// <copyright file="app.config.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: 10/09/2025 by Naziya Firdos
// </copyright>

import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection
} from "@angular/core";
import { provideRouter, withPreloading, PreloadAllModules } from "@angular/router";

import { routes } from "./app.routes";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { environment } from "../environments/environment";
import { provideTranslateService } from "@ngx-translate/core";
import { NgxPermissionsModule } from "ngx-permissions";
import { provideAnimations } from "@angular/platform-browser/animations";
import { AuthInterceptor } from "./features/authenticate/auth-interceptor";
import { tokenInitializer } from "./features/authenticate/token-initializer-service";

// Defines appConfig.
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideAnimations(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: environment.translation.prefix,
        suffix: environment.translation.suffix
      }),
      fallbackLang: environment.translation.fallbackLang,
      lang: environment.translation.lang
    }),
    provideAppInitializer(tokenInitializer()),
    importProvidersFrom(NgxPermissionsModule.forRoot())
  ]
};
